import { ProfileBlock } from "../../../../ui/blocks/profile/profileBlock";
import { UserDashboard } from "./userDashboard";


export function UserProfile(){

    return(
        <UserDashboard>
            <ProfileBlock/>
        </UserDashboard>
    );
};